<template>
  <div class="apply">
    <!-- 上半部分盒子 -->
    <div class="card_top">
      <!-- 左侧图片 -->
      <div class="card_img">
        <img
          :src="
            myitem.imgUrl == null
              ? 'https://fview.5kjs.com/style/camp/banner/camp_img.jpg'
              : myitem.imgUrl
          "
          @error="
            myitem.imgUrl =
              'https://fview.5kjs.com/style/camp/banner/camp_img.jpg'
          "
          alt=""
        />
      </div>
      <!-- 右侧文字区域 -->
      <div class="card_text_box">
        <!-- 拼团标题部分 -->
        <div class="Turan_title" v-if="TuanFlag">
          <div class="Turan_title_left">
            <span class="smll">99人拼团价</span>
            <span class="big" style="margin-left: 1rem">
              <span class="smll">￥</span>4890</span
            >
          </div>
          <div class="Turan_title_right">
            <span
              >距离结束仅剩：
              <downTime endTime="2022.1.24"></downTime>
            </span>
            <span></span>
          </div>
        </div>
        <!-- 标题 -->
        <div>
          <p class="card_title">
            <!-- <span class="title_class">[{{ myitem.sign_type }}]</span> -->
            {{ myitem.name }}
          </p>
        </div>
        <div class="desc">
          <p class="card_info_font" style="color: #000000">
            {{ myitem.brief_desc }}
          </p>
        </div>
        <!-- 时间等其他信息 -->
        <div class="card_info">
          <div class="card_info_item">
            <span v-if='myitem.allow_refund != 2 '>契 约 金：</span>
            <span v-else>价 格：</span>
            <span class="price_num">
              <span style="font-size: 18px; color: #f92f2f; font-weight: bold"
                >￥</span
              >
              <span class="price_num_txt">{{ myitem.price }}</span>
            </span>
            <span class="old_price">原价：{{ myitem.sale_price }}</span>
          </div>
          <div class="card_info_item" v-if="campInfo.is_hidden != 1">
            <span v-if='myitem.allow_refund != 2 '>契约天数：</span>
            <span v-else>特训天数：</span>
            <span class="colorRed">{{ myitem.days_num }}天</span>
          </div>
          
          <div class="card_info_item" v-if="campInfo.is_hidden != 1">
            <span>报名开始时间：</span>
            {{ this.myitem.sign_start_date }} ~
            {{ this.myitem.sign_end_date }}
          </div>
          <div class="card_info_item" v-if="campInfo.is_hidden != 1">
            <span>开营周期：</span>
            {{ myitem.begin_date }}~{{ myitem.end_date }}
          </div>
          <!-- 打卡方式部分 -->
          <div class="card_info_item">
            <span>打卡方式：</span>{{ myitem.sign_type }}
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                <p style="padding: 3px 0">
                  天数打卡：必须每天按时完成打卡任务。
                </p>
                <p>作业打卡：在报名后规定时间内完成所有打卡。</p>
              </div>
              <i class="iconfont icon-wenhao"></i>
            </el-tooltip>
          </div>
          <div class="card_info_item" v-if="campInfo.is_hidden != 1">
            <span>课程有效期：</span>
            {{ this.myitem.validity }} 止
          </div>
          <div class="card_info_item" v-else>
            <span>课程有效期：</span>
            一年
          </div>
          <!-- 活动倒计时数据功能未完善暂时注释 -->
          <!-- <div class="card_info_item camp_timeDown_box">
            <img
              class="camp_timeDown_box_bg"
              src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/camp_timeDown.png"
              alt=""
            />
            <div class="camp_timeDown_box_content">
              <div class="camp_timeDown_box_content_left">活动倒计时</div>
              <div class="camp_timeDown_box_content_right">
                1 天 13 时 23 分 18 秒
              </div>
            </div>
          </div> -->
          <!-- 资料下载、购前必读部分  -->
          <div class="detail_tips_box">
            <div
              class="detail_tips_item"
              v-if="fileList != null && fileList.files != null"
              @click="SlideBtn('ziliao')"
            >
              资料下载：共{{ fileList.num }}项
              <i class="iconfont icon-DownSanjiao"></i>
            </div>
            <div
              class="detail_tips_item"
              v-if="giveClassList != null && giveClassList.num != 0"
              @click="SlideBtn('giveClass')"
            >
              网课赠送：{{ giveClassList.num }}项
              <i class="iconfont icon-DownSanjiao"></i>
            </div>
            <div
              class="detail_tips_item"
              v-if="
                campInfo != null &&
                campInfo.lesson_before != null &&
                beforeTitle != null
              "
              @click="SlideBtn('third')"
            >
              学前必读
              <i class="iconfont icon-DownSanjiao"></i>
            </div>
          </div>
          <!-- 最下方按钮部分 -->
          <!-- 已购买状态 -->
          <div class="apply_bottom_Box" v-if="myis_apply">
            <div class="applay_btn apply_bottom_Box_btn" @click="classPass()">
              <!-- 由于访问权限问题,采用img方式 -->
              <img
                class="Buy_bg"
                src="	https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/buyBG.png"
                alt=""
              />
              <div class="red_content">开始学习</div>
            </div>
          </div>
          <!-- 报名已满或者停售 -->
          <div class="apply_bottom_Box" v-else-if="myitem.status == 'full'">
            <div
              class="applay_btn apply_bottom_Box_btn"
              style="background: #999"
              @click="fuln()"
            >
              <div class="red_content">报名已满</div>
            </div>
          </div>
          <!-- 停售状态 -->
          <div class="apply_bottom_Box" v-else-if="myitem.status == 'ending'">
            <div
              class="applay_btn apply_bottom_Box_btn"
              style="background: #999"
              @click="fuln()"
            >
              <div class="red_content">已停售</div>
            </div>
          </div>
          <!-- 未购买状态 -->
          <div class="apply_bottom_Box" v-else>
            <div class="applay_btn apply_bottom_Box_btn" @click="shopping()">
              <img
                class="Buy_bg"
                src="	https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/buyBG.png"
                alt=""
              />
              <div class="red_content">
                <img
                  class="ico"
                  src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/buy_ico.png"
                  alt=""
                />
                立即报名
              </div>
            </div>
            <div
              class="Add_card_btn apply_bottom_Box_btn"
              @click="setUserCart()"
            >
              <img
                class="ico"
                src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/add_card_ico.png"
                alt=""
              />
              加入购物车
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import downTime from "../downTime.vue";
export default {
  name: "apply_table",
  components: { downTime },
  props: {
    myitem: {
      tyoe: Object,
      default: () => {
        return {
          camp_id: "",
          name: "",
          begin_date: "", //「开营时间」
          end_date: "", //「结束时间」
          days_num: 4, //「开营天数」
          sign_type: "", //「打卡类型」
          status: "", //「特训营状态  signing:报名中  ending:已停售」
          sign_end_date: "", //「报名截止时间」
          imgUrl: null, //「特训营图片」
          sign_start_date: "",
        };
      },
    },
    myis_apply: {
      type: Boolean,
      default: false,
    },
    // 当前训练营是否为拼团状态由于在父页面还有平团相关元素，则值从父级页面继承而来
    TuanFlag: {
      type: Boolean,
      default: false,
    },
    campInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      // 模拟数据
      token: localStorage.getItem("token"),
      agency_id: localStorage.getItem("agency_id"),
      camp_id: null,
      sign_start_date: "",
      sign_end_date: "",
      // 加入购物车的节流阀
      addCardFlag: false,
    };
  },
  computed: {
    ...mapState(["fileList", "giveClassList"]),
    getID() {
      return { id: "1" };
    },
    beforeTitle() {
      let arr = this.campInfo.lesson_before;
      var title = null;
      arr.forEach((element) => {
        if (element.isgood == 1) {
          let num = element.lesson_name.search(/】|]/);
          if (num != -1) {
            title = element.lesson_name.slice(num + 1);
          }
        }
      });
      return title;
    },
  },
  methods: {
    ...mapActions(["asyncScrollToTop"]),
    // 未购买事件
    shopping() {
      // 防止token获取为空
      this.token = localStorage.getItem("token");
      let url = window.location.origin + "/buy/camp/";
      if (this.myitem.status == "signing") {
        // 如果用户没有登录点击了购买则跳转登录
        if (this.token == null) {
          let nowUrl = window.location.href;
          nowUrl = nowUrl.replace(/#/g, "vue");
          let url = window.location.origin;
          if (sessionStorage.getItem("distrid") != null) {
            window.location.href =
              url +
              "/login?turn_jump_url=" +
              nowUrl +
              "&distrid=" +
              sessionStorage.getItem("distrid");
          } else {
            window.location.href = url + "/login?turn_jump_url=" + nowUrl;
          }
        }

        this.$axios
          .get("/canBuy", {
            params: {
              token: this.token,
              agency_id: this.agency_id,
              camp_id: this.camp_id,
            },
          })
          .then((doc) => {
            if (doc == null) {
              if (sessionStorage.getItem("distrid") != null) {
                window.location.href =
                  url +
                  this.camp_id +
                  "?distrid=" +
                  sessionStorage.getItem("distrid");
              } else {
                window.location.href = url + this.camp_id;
              }

              //  window.location.href = "http://test2.5kjs.com"+ "/buy/camp/"+ 16
            } else if (doc.data.code == 201) {
              this.$alert(doc.data.message, "提示", {
                confirmButtonText: "确定",
              });
              location.reload();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        // 如果用户没有登录点击了已停售状态下的按钮则跳转登录
        if (this.token == null) {
          let nowUrl = window.location.href;
          nowUrl = nowUrl.replace(/#/g, "vue");
          let url = window.location.origin;
          if (sessionStorage.getItem("distrid") != null) {
            window.location.href =
              url +
              "/login?turn_jump_url=" +
              nowUrl +
              "&distrid=" +
              sessionStorage.getItem("distrid");
          } else {
            window.location.href = url + "/login?turn_jump_url=" + nowUrl;
          }
        } else {
          // 如果用户已登录但是点击了已停售的按钮则跳转往期回顾
          // this.$alert("该课程已经停售了噢~~~~", "提示", {
          //   confirmButtonText: "确定",
          // });
          this.$router.push({
            path: "/index/lookBack",
          });
        }
      }
    },
    // 已购买事件
    classPass() {
      this.$router.push({
        path: "/Detail/study/" + this.myitem.camp_id,
        query: { camp: this.myitem.camp_id },
      });
      this.asyncScrollToTop();
    },
    // 报名已满事件
    fuln() {
      this.$alert("该课程停止报名了噢~~~~", "提示", {
        confirmButtonText: "确定",
      });
    },
    // 页面锚点滑动事件
    SlideBtn(item) {
      this.$emit("slideBtn", item);
    },
    // 加入购物车
    setUserCart() {
      let ISlogin = localStorage.getItem("token");
      if (ISlogin == null) {
        // 未登录则跳转登录
        let nowUrl = window.location.href;
        nowUrl = nowUrl.replace(/#/g, "vue");
        let url = window.location.origin;
        if (sessionStorage.getItem("distrid") != null) {
          window.location.href =
            url +
            "/login?turn_jump_url=" +
            nowUrl +
            "&distrid=" +
            sessionStorage.getItem("distrid");
        } else {
          window.location.href = url + "/login?turn_jump_url=" + nowUrl;
        }
      }

      if (this.addCardFlag) {
        return;
      }
      // 开启节流阀
      this.addCardFlag = true;

      let origin = window.location.origin;
      origin =
        origin == "http://localhost:8080" ? "http://hnjszp.xueba.hk" : origin;

      this.$axios
        .post(`${origin}/api`, {
          apiName: "setUserCart",
          type: "camp",
          id: this.camp_id,
        })
        .then((result) => {
          this.addCardFlag = false;
          console.log(result.info);
          // var reg = RegExp(/未登录/);
          // if (reg.exec(result.info) != null) {
          //   this.$message("您还未登录，请先登录。");
          //   setTimeout(() => {}, 2000);
          // } else {}
          this.$message({
            message: "加入购物车成功",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("网络错误，请稍后再试");
        });
    },
  },
  watch: {
    myis_apply(v) {
      return v;
    },
  },
  mounted() {
    this.camp_id = this.$route.params.id;
    this.sign_start_date = this.myitem.sign_start_date;
    this.sign_end_date = this.myitem.sign_end_date;
    setTimeout(() => {
      this.token = localStorage.getItem("token");
      this.agency_id = localStorage.getItem("agency_id");
    }, 300);
  },
};
</script>

<style lang="less" scoped>
.FRcenter {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.apply {
  //   margin-top: 1.1875rem;
  height: auto;
  width: 100%;
  // 把整个图片分成了上下两部分。
  // top为上半部分，为图片以及课程内容部分
  .card_top {
    // 上半部分的图片部分
    width: 100%;
    // height: 20.8125rem;
    display: flex;
    flex-direction: row;
    .card_img {
      width: 32.1875rem;
      height: 24rem;
      background: #e8e8e8;
      border-radius: 0.625rem;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 上半部分的右侧文字部分
    .card_text_box {
      flex: 1;
      margin-left: 2.375rem;
      width: 39.375rem;
      height: 100%;

      // 拼团标题部分
      .Turan_title {
        margin-bottom: 1.1875rem;
        padding: 0 2.3125rem;
        height: 51px;
        background: linear-gradient(144deg, #ff5a25, #ff7d3a);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        color: #fff;
        font-family: Microsoft YaHei;
        .smll {
          font-size: 1rem;
        }
        .big {
          font-size: 1.75rem;
        }
        .Turan_title_right {
          font-size: 1.125rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          /deep/ .time {
            display: inline-block;
            background-color: #fff;
            border-radius: 2px;
            color: #ff4d6c;
            margin: 0 0.3125rem;
            padding: 0 0.1875rem;
          }
          /deep/ .time:nth-child(1) {
            background-color: transparent;
            color: #fff;
            padding: 0;
            margin: 0;
          }
        }
      }

      // 右侧标题
      .card_title {
        font-size: 1.75rem;
        font-family: " Microsoft YaHei";
        font-weight: bold;
        color: #333333;
        line-height: 1.825rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        .title_class {
          font-size: 1.625rem;
          font-weight: 400;
        }
      }
      .desc {
        margin-top: 0.8rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      // 拼团按钮和单独购买按钮部分
      .Tuan_btn {
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #585858;
        .Tuan_btn_Box {
          margin-top: 0.875rem;
          display: flex;
          flex-direction: row;
          // 按钮公共样式
          .btn_box {
            cursor: pointer;
            width: 12.875rem;
            height: 4.5625rem;
            background: #ffffff;
            border: 1px solid #ff6125;
            border-radius: 0.4375rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .btn_box_big {
              font-size: 1.5rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
            }
            .btn_box_smll {
              font-size: 1.125rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
            }
          }
          // 单独购买按钮
          .alone_buy {
            color: #ff7d3a;
          }
          // 拼团购买样式
          .team_buy {
            margin-left: 0.5rem;
            color: #ffffff;
            background-color: #fff;
            background: linear-gradient(144deg, #ff5a25, #ff7d3a);
          }
        }
      }

      // 价格部分
      .price {
        width: 100%;
        // height: 3.9375rem;
        padding: 0.7rem 0;
        border: 0.0625rem dashed #e3e3e3;
        border-left: none;
        border-right: none;
        // line-height: 3.9375rem;
        // font-size: 1.625rem;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        color: #fa6a61;
        .price_font {
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #585858;
        }
      }
      //信息部分
      .card_info {
        display: flex;
        flex-direction: column;
        width: 100%;
        // 新版详情页内容
        .card_info_item {
          margin-top: 16px;
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #8a8a8a;
          .price_num {
            .price_num_txt {
              font-size: 28px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #f92f2f;
            }
          }
          .old_price {
            margin-left: 3px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            text-decoration: line-through;
            color: #a0a0a0;
          }
          .colorRed {
            color: #f92f2f;
          }
        }
        // 活动倒计时部分
        .camp_timeDown_box {
          position: relative;
          width: 257px;
          height: 24px;

          .camp_timeDown_box_bg {
            z-index: 0;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }

          .camp_timeDown_box_content {
            z-index: 1;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-items: center;
            align-items: center;
            .camp_timeDown_box_content_left {
              padding-left: 5px;
              width: 90px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
            }
            .camp_timeDown_box_content_right {
            }
          }
        }
        // 资料下载购前必读部分
        .detail_tips_box {
          margin-top: 1.875rem;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          .detail_tips_item {
            cursor: pointer;
            margin-right: 0.625rem;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding: 0 0.8125rem 0 1.125rem;
            height: 1.75rem;
            background: #ffffff;
            border: 1px solid #f92f2f;
            border-radius: 1px;
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #f92f2f;
            .icon-DownSanjiao {
              transform: scale(0.8);
              padding-top: 0.125rem;
              font-size: 0.75rem;
            }
          }
        }

        // 最下方按钮部分
        .apply_bottom_Box {
          margin-top: 1.25rem;
          padding-top: 1.25rem;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          border-top: 1px dashed #d8d8d8;
          // 通用按钮样式
          .apply_bottom_Box_btn {
            cursor: pointer;
            margin-right: 1.125rem;
            width: 12.375rem;
            height: 2.5625rem;
            background: linear-gradient(90deg, #dc9d31, #e0b16b);
            box-shadow: 0px 3px 8px 0px rgba(139, 78, 0, 0.2);
            border-radius: 0.3125rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size: 1.125rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            &:hover {
              text-decoration: underline;
              .red_content {
                text-decoration: underline;
              }
            }
            .ico {
              margin-right: 0.375rem;
              height: 1.125rem;
            }
          }

          // 红色按钮
          .applay_btn {
            position: relative;
            .Buy_bg {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
            }
            .red_content {
              z-index: 9;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
      // 右侧报名按钮
      .apply {
        margin-top: 1rem;
        box-sizing: border-box;
        position: relative;
        width: 100%;
        height: 4.5625rem;
        display: flex;
        // flex-direction: column;
        align-items: center;
        padding-left: 1rem;
        background-color: #424c5b;
        border-radius: 0.4375rem;
        .fontSize20 {
          font-size: 1.25rem;
        }
        .apply_font {
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #ffffff;
          line-height: 1.6875rem;
        }
        .applyBtn {
          position: absolute;
          right: 0;
          top: 0;
          width: 13.8125rem;
          height: 4.5625rem;
          background: linear-gradient(144deg, #ff5a25, #ff7d3a);
          border-radius: 0.4375rem;
          .applyBtn_now {
            height: 100%;
            font-size: 1.625rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #ffffff;
            // line-height: 4.5625rem;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .sm {
              font-size: 0.8rem;
              .iconfont::before {
                font-size: 0.8rem;
              }
            }
          }
          .stop {
            // cursor: not-allowed;
          }
        }
        .applyBtn:hover {
          background: linear-gradient(144deg, #ff7d3a, #ff5a25);
        }
      }
      // 资料下载锚点盒子
      .file_tips {
        cursor: pointer;
        padding: 0.7rem 0;
        border-bottom: 0.0625rem dashed #e3e3e3;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: center;
        .file_tips_left {
          padding: 0.375rem 0.75rem;
          // height: 1.5625rem;
          background: #ffffff;
          border: 0.0625rem solid #fd6060;
          border-radius: 0.25rem;
          span {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fd8787;
          }
        }

        .file_tips_right {
          .FRcenter();
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #585858;
        }
      }
      // 学前必读部分
      .only {
        cursor: pointer;
        margin: 1.25rem 0;
        background: #fff1ee;
        border-radius: 0.625rem;
        padding: 1.375rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: center;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fd6060;
        .only_left {
          font-size: 1rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fd6060;
        }

        .only_right {
          font-size: 0.75rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fd6060;
          flex-shrink: 0;
          margin-left: 1rem;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

.num {
  margin-left: 21px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #a5a8ae;
  text-decoration: line-through;
}
</style>